import { PcDriver } from '@acorn-portal/shared/src/services/subscriptionAPI';
import { areDriversUnchanged } from '../amend-drivers/utils/are-drivers-unchanged';

type ReturnValue = { isValid: boolean; message?: string };

/**
 * Validates the data for the amend drivers journey - currently relating to the Subscription API only.
 * Ensures at least one driver is present and that changes have been made compared to the original data.
 *
 * @param workingDriverData - The current list of drivers being amended.
 * @param originalDriverData - The original list of drivers before amendment.
 * @returns An object containing `isValid` (boolean) and an optional `message` (string).
 */
export function validateDriverData(workingDriverData: PcDriver[], originalDriverData: PcDriver[]): ReturnValue {
	if (workingDriverData.length === 0) {
		return { isValid: false, message: 'You must add at least one driver to the policy.' };
	}
	const driversUnchanged = areDriversUnchanged(originalDriverData, workingDriverData);
	if (driversUnchanged) {
		return {
			isValid: false,
			message: 'You are unable to proceed, as you did not make any changes to your policy.',
		};
	}

	const mainDriverPresent = workingDriverData.some((driver) => driver.mainDriver);
	if (!mainDriverPresent) return { isValid: false, message: 'You must have a main driver on the policy.' };

	return { isValid: true };
}
